<template>
  <v-card flat tile>
    <v-progress-linear color="teal darken-4" height="30" :value="indicadorSelecionado.porcentagemTotalAtingido" striped>
      <template v-slot:default="{ value }">
        <v-chip class="font-weight-bold" color="teal darken-2" text-color="white" small> {{ value ? value.toFixed(2): ''}}%</v-chip>
      </template>
    </v-progress-linear>      
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-form>
            <p class="text-h5">Fontes de Verificação</p>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text class="px-5 my-n3">
      <LancamentoAdiciona v-if="isPermissao"
        titulo="Abrir lançamento de fontes"
        :indicador="indicadorSelecionado"
      ></LancamentoAdiciona>
    </v-card-text>

    <v-card-text class="px-5" v-if="asyncDataStatus_ready">
      <v-data-table
        class="indicador-table"
        :headers="headers"
        :items="lancamentos"
        :search="search"
        no-data-text="Não há lançamentos disponíveis"
        no-results-text="Nenhum lançamento encontrado"
        sort-by="ordem"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td> {{item.descricaoPrevisao}} </td>
            <td> {{item.descricao}} </td>
            <td>
              <span>{{
                item.lancadoPor ? item.lancadoPor.nome : "Aguardando definição"
              }}</span>
            </td>
            <td>
              <span v-if="item.statusLancamento === 'ABERTO'"><v-chip class="ma-2" dark color="indigo">ABERTO</v-chip></span>
              <span v-if="item.statusLancamento === 'AGUARDANDO_MONITORAMENTO'"><v-chip class="ma-2" color="info">AGUARDANDO MONITORAMENTO</v-chip></span>
              <span v-if="item.statusLancamento === 'MONITORAMENTO_REALIZADO'"><v-chip class="ma-2" color="success">MONITORAMENTO REALIZADO</v-chip></span>                  
              <span v-if="item.statusLancamento === 'AGUARDANDO_CORRECAO'"><v-chip class="ma-2" color="warning">AGUARDANDO CORREÇÕES</v-chip></span>                  
            </td>
            <td> 
              {{
                item.monitoradoEm ? formatDate(item.monitoradoEm) : ""
              }}            
            </td>
            <td>
              {{
                item.monitoradoPor ? item.monitoradoPor.nome : ""
              }}
            </td>
            <td>{{ item.progresso > 0 ? item.progresso : "" }}</td>
            <td>
              <FonteVerificacaoGerenciamento :isPermissao="isPermissaoLancamento(item.lancadoPor, item.monitoradoPor)" :lancamento="item" :indicador="indicadorSelecionado"></FonteVerificacaoGerenciamento>

              <LancamentoEdita v-if="isPermissao"
                titulo="Editar Lançamento de Fonte"
                :indicador="indicadorSelecionado"
                :lancamentoFonte="item"
                style="display: inline;"
              ></LancamentoEdita>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import LancamentoAdiciona from "@/pages/Projeto/components/FonteVerificacao/LancamentoAdiciona";
import LancamentoEdita from "@/pages/Projeto/components/FonteVerificacao/LancamentoEdita";
import FonteVerificacaoGerenciamento from "@/pages/Projeto/components/FonteVerificacao/Gerenciamento/FonteVerificacaoGerenciamento";

import asyncDataStatus from "@/mixins/asyncDataStatus";
import { mapActions } from "vuex";

export default {
  name: "FonteVerificacao",

  components: {
    LancamentoAdiciona,
    LancamentoEdita,
    FonteVerificacaoGerenciamento
  },
  
  mixins: [asyncDataStatus],

  props: {
    indicadorSelecionado: {
      require: false,
    },
    isPermissao: {
      require: true
    }
  },

  watch: {
    indicadorSelecionado(){
      //this.fetchLancamentos(this.indicadorSelecionado.id).then(() => {
      this.fetchLancamentos(this.$route.params.indicadorId).then(() => {
        this.asyncDataStatus_fetched();
      });
    },  
  },

  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        { text: "Previsão de lançamento", align: "start", value: "mes" },
        { text: "Mês de lançamento", align: "start", value: "mes" },
        { text: "Lançado por", value: "lancadoPor.nome" },
        { text: "Status", value: "statusLancamento" },
        { text: "Monitorado em", value: "statusLancamento" },
        { text: "Monitorado por", value: "monitoradoPor.nome" },
        { text: "Progresso", value: "progresso" },
        { text: "Ações" },
      ],
    };
  },
  computed: {
    lancamentos() {
      return this.$store.getters["lancamento/byIndicadorId"](this.indicadorSelecionado.id);
    },
    usuario() {
      return this.$store.getters["usuario/getUser"];
    },    
  },
  methods: {
    ...mapActions("lancamento", ["fetchLancamentos"]),
    
    isPermissaoLancamento(lancadoPor, monitoradoPor) {
      if(this.isPermissao) {
        return true
      }

      if(lancadoPor) {
        if(lancadoPor.id === this.usuario.id) {
          return true
        }
      }

      if(monitoradoPor) {
        if(monitoradoPor.id === this.usuario.id) {
          return true
        }
      }

      return false
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

  },
  created() {
    this.fetchLancamentos(this.indicadorSelecionado.id).then(() => {
      this.asyncDataStatus_fetched();
    });
  },
};
</script>
